import { ActionCreatorWithPayload, createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum SideBarOptions {
  APPLICATIONS = "APPLICATIONS",
  USERS = "USERS",
  INFORMATION_ASSETS = "INFORMATION_ASSETS",
  POLICIES = "POLICIES",
  USER_GUIDE = "USER_GUIDE",
}

export type AppSideBarPageState = {
  selectedSideBar: string;
  isCollapsed: boolean;
}

const initialState: AppSideBarPageState = {
  selectedSideBar: "",
  isCollapsed: false
};

const appSideBarPageSlice = createSlice({
  name: "appSideBarPage",
  initialState,
  reducers: {
    updateAppSideBarPageSliceState: (state: AppSideBarPageState, action: PayloadAction<AppSideBarPageState>) => ({
      ...state,
      ...action.payload,
    }),
  },
  extraReducers: {},
});

export const AppSideBarPageReducer = appSideBarPageSlice.reducer;

const updateAppSideBarPageState: ActionCreatorWithPayload<Partial<AppSideBarPageState>> =
  appSideBarPageSlice.actions.updateAppSideBarPageSliceState;

const updateSelectedSideBar = (selectedSideBar: string) =>
  updateAppSideBarPageState({ selectedSideBar: selectedSideBar });

const updateSideBarStatus = (isCollapsed: boolean) =>
  updateAppSideBarPageState({ isCollapsed: isCollapsed });

export const AppSideBarPageActions = {
  updateSelectedSideBar,
  updateSideBarStatus
};
